<template>
    <div
        ref="draggable"
        class="cursor-grab overflow-hidden"
        @mousedown="startDrag"
        @mouseup="stopDrag"
        @mouseleave="stopDrag"
        @mousemove="drag"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'DraggableComponent',
    data() {
        return {
            isDragging: false,
            startX: 0,
            scrollLeft: 0,
        };
    },
    methods: {
        startDrag(event) {
            this.isDragging = true;
            this.startX = event.pageX - this.$refs.draggable.offsetLeft;
            this.scrollLeft = this.$refs.draggable.scrollLeft;
            this.$refs.draggable.classList.add('cursor-grabbing');
        },
        stopDrag() {
            this.isDragging = false;
            this.$refs.draggable.classList.remove('cursor-grabbing');
        },
        drag(event) {
            if (!this.isDragging) return;
            event.preventDefault();
            const x = event.pageX - this.$refs.draggable.offsetLeft;
            const walk = (x - this.startX) * 2; // Регулируем скорость перетаскивания
            this.$refs.draggable.scrollLeft = this.scrollLeft - walk;
        },
    },
};
</script>

<style scoped>

</style>
